import React from 'react'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import Stack from '@mui/material/Stack'
import Link from '@mui/material/Link'
import { COLORS } from '../../../config/constants'
import Button from '@mui/material/Button'
import { Add, ChevronRight } from '@vedmarket/ui-kit'

import './headerTitle.scss'
import { Link as RouterLink, useNavigate } from 'react-router-dom'
import Breadcrumbs from '@mui/material/Breadcrumbs'

const HeaderTitle = ({ menuText, titleText, link, count, breadcrumbs }: CommonHeaderTitleProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleClick = () => {
    if (!link) {
      return
    }
    navigate(link)
  }

  return (
    <div className='routes-header-container'>
      <Stack spacing={2}>
        {breadcrumbs ? (
          <Breadcrumbs
            separator={<ChevronRight fontSize='small' />}
            aria-label='breadcrumb'
          >
            {breadcrumbs}
          </Breadcrumbs>
        ) : (
          <Link
            underline='hover'
            key='main'
            color={COLORS.LIGHT_TEXT_SECONDARY}
            component={RouterLink}
            to='/'
            sx={{ display: 'flex', alignItems: 'center', fontSize: '14px' }}
          >
            <Typography variant='body2' component='span'>{t('menu__text__main')}</Typography>
          </Link>
        )}
      </Stack>
      <div className='routes-header'>
        <Typography
          variant='h4'
          sx={{
            fontSize: '32px',
            fontWeight: 700,
            position: 'relative',
          }}
        >
          {titleText}
          {Boolean(count) && (
            <Typography
              variant='h4'
              sx={{
                color: COLORS.LIGHT_TEXT_DISABLED,
                fontSize: '18px',
                position: 'absolute',
                top: '4px',
                left: 'calc(100% + 8px)',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              +{count}
            </Typography>
          )}
        </Typography>
        {menuText && (
          <Button
            variant='contained'
            type='submit'
            sx={{ width: '360px', fontSize: '15px' }}
            startIcon={<Add width={24} height={24} />}
            onClick={handleClick}
          >
            <Typography component='span' sx={{ fontSize: 'inherit', fontWeight: 'inherit', lineHeight: 'inherit', letterSpacing: 'inherit' }}>{menuText}</Typography>
          </Button>
        )}
      </div>
    </div>
  )
}

export default HeaderTitle
